__turbopack_context__.v({
  "cardArt": "VrGDMq_cardArt",
  "container": "VrGDMq_container",
  "dropdown": "VrGDMq_dropdown",
  "iconLogo": "VrGDMq_iconLogo",
  "iconSearch": "VrGDMq_iconSearch",
  "iconSearchMagnifyingGlass": "VrGDMq_iconSearchMagnifyingGlass",
  "iconSearchSpinner": "VrGDMq_iconSearchSpinner",
  "input": "VrGDMq_input",
  "loading": "VrGDMq_loading",
  "result": "VrGDMq_result",
  "resultIcon": "VrGDMq_resultIcon",
  "resultIconImage": "VrGDMq_resultIconImage",
  "resultImage": "VrGDMq_resultImage",
  "resultLabel": "VrGDMq_resultLabel",
  "size--lg": "VrGDMq_size--lg",
});
